var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4982 29.0176C38.1308 29.2741 40.9981 32.3022 40.9981 36V40C40.9981 40.5523 41.4458 41 41.9981 41C42.5503 41 42.9981 40.5523 42.9981 40V36C42.9981 31.0294 38.9686 27 33.9981 27H32.3242C33.1367 27.5722 33.8682 28.2515 34.4982 29.0176Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 29C10.134 29 7 32.134 7 36V40C7 40.5523 6.55228 41 6 41C5.44772 41 5 40.5523 5 40V36C5 31.0294 9.02944 27 14 27H26C30.9706 27 35 31.0294 35 36V40C35 40.5523 34.5523 41 34 41C33.4477 41 33 40.5523 33 40V36C33 32.134 29.866 29 26 29H14Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.002 20C31.3154 19.9996 34.0013 17.3135 34.0013 14C34.0013 10.6865 31.3154 8.00039 28.002 8C27.496 7.32637 26.9069 6.71872 26.25 6.19227C26.8136 6.0664 27.3997 6 28.0013 6C32.4195 6 36.0013 9.58172 36.0013 14C36.0013 18.4183 32.4195 22 28.0013 22C27.3997 22 26.8136 21.9336 26.25 21.8077C26.9069 21.2813 27.496 20.6736 28.002 20Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20C23.3137 20 26 17.3137 26 14C26 10.6863 23.3137 8 20 8C16.6863 8 14 10.6863 14 14C14 17.3137 16.6863 20 20 20ZM20 22C24.4183 22 28 18.4183 28 14C28 9.58172 24.4183 6 20 6C15.5817 6 12 9.58172 12 14C12 18.4183 15.5817 22 20 22Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users-2.55db84f432108668003e246fc0d44d08.svg";
export { ForwardRef as ReactComponent };